var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    _vm.tag,
    {
      tag: "component",
      staticClass: "gfu-countdown-clock",
      attrs: { "data-qa": _vm.dataQa },
    },
    [
      _vm.isClockVisible
        ? _vm._l(_vm.segments, function (segment) {
            return _c("div", { key: segment.key }, [
              _c(
                "div",
                {
                  staticClass: "gfu-countdown-clock__value",
                  attrs: { "data-qa": `clock-segment:${segment.key}` },
                },
                [_vm._v(_vm._s(segment.value))]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "gfu-countdown-clock__label" }, [
                _vm._v(_vm._s(segment.label)),
              ]),
            ])
          })
        : _vm._t(
            "finished",
            function () {
              return [
                _c("div", { staticClass: "gfu-countdown-clock__value" }, [
                  _vm._v(_vm._s(_vm.elapsedMessage)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "gfu-countdown-clock__label" }),
              ]
            },
            { dataQa: "countdown-clock-imminent" }
          ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }